// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aWHE{background:#fff;border:1px solid #d0d0d0;border-radius:8px;box-sizing:border-box;display:flex;position:relative}.aWHE:hover{border-color:#fecdb4}.oN3t{border:2px solid #fecdb4}._8eyr{border-color:#fe675e!important}.EO\\+H{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:#fff;border:none;border-radius:8px;box-sizing:border-box;color:#616161;font-size:14px;font-weight:400;height:48px;padding:14px 16px;position:relative;width:100%;z-index:1}.EO\\+H::-moz-placeholder{color:#bbb;font-size:14px;font-weight:400}.EO\\+H::placeholder{color:#bbb;font-size:14px;font-weight:400}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phone": "aWHE",
	"phoneFocus": "oN3t",
	"phoneError": "_8eyr",
	"phoneInput": "EO+H"
};
module.exports = ___CSS_LOADER_EXPORT___;
